module.exports = __webpack_public_path__ + "img/icon_question.d0fedf36.png";